import { useState, useEffect } from "react";
import axios from "axios";
import MainLayout from "../layouts/MainLayout";
import AddClient from "./AddClient";
import EditClient from "./EditClient";

function Clients() {

const [clients,setClients]=useState([]);
const [search,setSearch]=useState("");
const [showAddDialog,setShowAddDialog]=useState(false);

const [showEditDialog,setShowEditDialog]=useState(false);
const [selectedClient,setSelectedClient]=useState(null);

useEffect(()=>{

loadClients();

},[]);

const loadClients=async()=>{

try{

const token=localStorage.getItem("token");

const response=await axios.get(

"https://saleupcall.com/api/Client/get-clients.php",

{
headers:{
Authorization:`Bearer ${token}`
}
}

);

if(response.data.status){

setClients(
response.data.data
);

}

}
catch(error){

console.log(error);

}

};

const filteredClients=

clients.filter(

(client)=>

(client.company_name || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(client.contact_person || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(client.mobile || "")
.includes(search)

||

(client.city || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(client.state || "")
.toLowerCase()
.includes(search.toLowerCase())

||

(client.pin_code || "")
.includes(search)

);

const deleteClient=async(id)=>{

if(
!window.confirm(
"Delete this client?"
)
){
return;
}

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Client/delete-client.php",

{
id:id
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Deleted"
);

loadClients();

}

};

const printTable=()=>{

window.print();

};

return(

<MainLayout><style>

{`

@media print{

.d-print-none{
display:none !important;
}

/* sidebar hide */

.sidebar{
display:none !important;
}

aside{
display:none !important;
}

nav{
display:none !important;
}

/* main content full width */

main{
width:100% !important;
margin:0 !important;
padding:0 !important;
}

.container{
width:100% !important;
max-width:100% !important;
}

.table-responsive{
overflow:visible !important;
}

#clientTable{
width:100% !important;
font-size:11px;
}

#clientTable th:last-child,
#clientTable td:last-child{
display:none !important;
}

}

`}

</style>
<div className="container mt-1">

<div className="row mb-2">

<div className="col-md-4">

<h4>Clients</h4>

</div>

<div className="col-md-6 d-print-none">

<input
type="text"
className="form-control form-control-sm"
placeholder="Search Client"
value={search}
onChange={(e)=>
setSearch(
e.target.value
)
}
/>

</div>

<div className="col-md-2 d-flex gap-1">

<button
className="btn btn-success btn-sm w-50 d-print-none"
onClick={()=>
setShowAddDialog(true)
}
>

<i className="bi bi-plus-lg"></i>

</button>

<button
className="btn btn-secondary btn-sm w-50 d-print-none"
onClick={printTable}
>

<i className="bi bi-printer "></i>

</button>

</div>

</div>

<div className="table-responsive ">

<table
id="clientTable"
className="table table-bordered table-hover table-striped table-sm"
>

<thead className="table-success">

<tr>

<th>ID</th>
<th>Company</th>
<th>Contact Person</th>
<th>Mobile</th>
<th>City</th>
<th>State</th>
<th>Pin Code</th>
<th>Username</th>
<th>Email</th>
<th width="150">Actions</th>

</tr>

</thead>

<tbody>

{

filteredClients.map(

(client)=>(

<tr key={client.id}>

<td>{client.id}</td>
<td>{client.company_name}</td>
<td>{client.contact_person}</td>
<td>{client.mobile}</td>
<td>{client.city}</td>
<td>{client.state}</td>
<td>{client.pin_code}</td>
<td>{client.username}</td>
<td>{client.email}</td>

<td>

<button
className="btn btn-primary btn-sm me-1"
onClick={()=>{

setSelectedClient(client);

setShowEditDialog(true);

}}
>

<i className="bi bi-pencil"></i>

</button>

<button
className="btn btn-danger btn-sm me-1"
onClick={()=>deleteClient(client.id)}
>

<i className="bi bi-trash"></i>

</button>

<button
className="btn btn-info btn-sm"
>

<i className="bi bi-eye"></i>

</button>

</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</div>

{
showAddDialog && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Add Client</h5>

<button
className="btn-close"
onClick={()=>
setShowAddDialog(false)
}
></button>

</div>

<div className="modal-body">

<AddClient
onClose={()=>{
setShowAddDialog(false);
loadClients();
}}
/>

</div>

</div>

</div>

</div>

)

}

{
showEditDialog &&
selectedClient && (

<div
className="modal d-block"
style={{
background:"rgba(0,0,0,.5)"
}}
>

<div className="modal-dialog modal-xl">

<div className="modal-content">

<div className="modal-header">

<h5>Edit Client</h5>

<button
className="btn-close"
onClick={()=>{

setShowEditDialog(false);
setSelectedClient(null);

}}
>

</button>

</div>

<div className="modal-body">

<EditClient
client={selectedClient}
onClose={()=>{

setShowEditDialog(false);
setSelectedClient(null);

loadClients();

}}
/>

</div>

</div>

</div>

</div>

)

}

</MainLayout>

);

}

export default Clients;